import {Component} from '@angular/core';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {DocumentsService} from './documents.service';

@Component({
  selector: 'documents-grid',
  templateUrl: './documents.component.html',
  providers: [DocumentsService],
})
export class DocumentsComponent {
  public documents;
  public doctypes = ['docx', 'doc', 'xls', 'xlsx', 'pdf', 'csv', 'txt', 'csv'];
  public errors: any = {};
  public group = 'documents';

  constructor(
    public documentsService: DocumentsService,
    public securityService: SecurityService,
    public logger: LogService,
    public visualsService: VisualsService,
    public eventsEmitterService: EventsEmitterService,
  ) {
    this.loadDocuments();
    this.loadErrors();

    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadErrors();
      },
    });
  }

  public loadDocuments() {
    this.documentsService.getDocuments().subscribe({
      next: (data) => {
        if (data.length == 0) {
          this.documentsService.handleError(this.errors['noDocs']);
        } else {
          this.documents = data;
        }
      },
      error: (error) => {
        this.logger.log(error);
        //this.documentsService.handleError(this.errors['noDocs']);
      },
    });
  }

  public loadErrors() {
    this.errors = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
  }

  public download(path: string, name: string) {
    if (
      this.doctypes.lastIndexOf(name.substring(name.lastIndexOf('.') + 1, name.length).trim()) > -1
    ) {
      this.documentsService.downloadFile(path, name).subscribe({
        next: (data) => {
          this.logger.log('Downloaded file');
        },
        error: (error) => {
          this.logger.log('Error Dowloading file');
        },
      });
    }
  }
}
